export enum Lang {
  EN = 'en',
  UA = 'ua',
}